'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useTimeRecordingStore } from '@repo/store/useTimeRecordingStore'

export const ActivitySelect = ({
  testData = null,
  privateOrLegalAid,
  workflowTypeId,
  crmSchemeId,
  remunerationTypeId,
  branchId,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx,
  required,
  menuZindex = 1100,
  onActivityError,
  formMode,
  index,
  menuWidth = null
}) => {
  const { fetchActivities, activities, fetchingActivities } = useTimeRecordingStore()
  const [isDisabled, setIsDisabled] = useState(false)
  const [options, setOptions] = useState(testData || activities || [])

  const handleChange = (newValue) => {
    onChange(newValue)
  }

  useEffect(() => {
    if (testData) return
    setOptions(activities || [])

    if (
      formMode !== 'createTimer' &&
      index === 0 &&
      remunerationTypeId &&
      privateOrLegalAid &&
      workflowTypeId &&
      !activities?.length &&
      !fetchingActivities
    ) {
      if (onActivityError) onActivityError('No chargeable activities match your criteria. Please try again')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData, activities])

  useEffect(() => {
    if (testData || !privateOrLegalAid) return

    if (privateOrLegalAid === 'P' && !workflowTypeId) return

    const invalidCrmSchemeId = crmSchemeId === null || crmSchemeId === undefined
    const invalidBranchId = branchId === null && branchId === undefined
    const invalid = invalidCrmSchemeId || invalidBranchId || !remunerationTypeId
    if (privateOrLegalAid === 'L' && invalid) return

    fetchActivities({ privateOrLegalAid, workflowTypeId, crmSchemeId, remunerationTypeId, branchId })
  }, [testData, fetchActivities, privateOrLegalAid, workflowTypeId, crmSchemeId, remunerationTypeId, branchId])

  useEffect(() => {
    if (!privateOrLegalAid) {
      setIsDisabled(true)
      return
    }

    if (privateOrLegalAid === 'P') {
      setIsDisabled(!workflowTypeId)
      return
    }

    const invalidCrmSchemeId = crmSchemeId === null || crmSchemeId === undefined
    const invalidBranchId = branchId === null && branchId === undefined

    setIsDisabled(invalidCrmSchemeId || invalidBranchId || !remunerationTypeId)
  }, [remunerationTypeId, crmSchemeId, branchId, privateOrLegalAid, workflowTypeId])

  return (
    <div data-testid="ActivitySelect">
      <ReactSelectMenu
        label="Activity"
        disabled={isDisabled || !options.length}
        onChange={handleChange}
        items={options}
        value={value || null}
        sx={sx}
        searchable
        valueKey="timeRecordingActivityId"
        labelKey="timeRecordingActivityDescription"
        required={required}
        menuZindex={menuZindex}
        menuWidth={menuWidth}
      />
    </div>
  )
}

ActivitySelect.propTypes = {
  testData: PropTypes.array,
  privateOrLegalAid: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func,
  workflowTypeId: PropTypes.string,
  crmSchemeId: PropTypes.number,
  remunerationTypeId: PropTypes.string,
  branchId: PropTypes.number,
  sx: PropTypes.object,
  required: PropTypes.bool,
  menuZindex: PropTypes.number,
  onActivityError: PropTypes.func,
  formMode: PropTypes.string,
  index: PropTypes.number,
  menuWidth: PropTypes.string
}
